import { styled } from "styled-components";
const CardContentWrapper = styled("header")(
  {
    padding: 16
  },
  ({ $noWrap }) => $noWrap ? {
    whiteSpace: "nowrap"
  } : void 0,
  ({ $clipRight }) => $clipRight ? { paddingRight: 48 } : void 0
);
export {
  CardContentWrapper
};
